import { Directive, ElementRef, OnInit, inject } from '@angular/core';
import {
  StylePreferenceEnum,
  StylePreferencesService,
} from '../services/style-preferences.service';

@Directive({
  selector: '[orgbrainStyle]',
    standalone: false
})
export class StyleDirective implements OnInit {
  private element = inject(ElementRef);
  private stylePreferences = inject(StylePreferencesService);


  ngOnInit() {
    if (this.stylePreferences.getPreference(StylePreferenceEnum.wrapTabLabels)) {
      const labelsList = this.element.nativeElement.getElementsByClassName('mat-tab-labels');

      if (labelsList.length === 1) {
        const classList = labelsList[0].classList;
        classList.add('orgbrain-mat-tab-labels-wrap');
      }
    }
  }
}
